export const Environments = {
    DockerCompose: 'DockerCompose',
    Development: 'development',
    Production: 'production'
};
